import { ComponentType } from 'react'

import ChecklistContextProvider from './checklist-context/checklist-context'

const withChecklistContext = <T extends object>(Component: ComponentType<T>) => {
  const Wrapped = (props: any) => (
    <ChecklistContextProvider {...props}>
      <Component {...props} />
    </ChecklistContextProvider>
  )

  return Wrapped
}

export default withChecklistContext
